module.exports = __webpack_public_path__ + "static/media/slider-home-business-slide-01-bg.ee554567.jpg";